export default class ShyListener {
  constructor() {
    this.shyOffset = 250;
    this.shyClass = 'js-shy';
    this.lastUp = window.pageYOffset;

    window.addEventListener("scroll", () =>
      this.scrollListener(window.pageYOffset)
    );
    document.addEventListener("DOMContentLoaded", () =>
      setTimeout(() =>
        this.scrollListener(window.pageYOffset)
      , 500)
    );

  }

  scrollListener(top) {
    if (
      top < this.lastUp ||
      document.querySelector(".site-header")?.classList.contains("js-menu-open") ||
      document.querySelector("body")?.classList.contains("js-mobile-menu-open")
    ) {
      this.showShy(top);
    } else if (top > this.shyOffset + this.lastUp) {
      this.hideShy(top);
    }
  }

  hideShy(top = window.pageYOffset) {
    document.body.classList.add(this.shyClass);
    this.lastUp = top;
  }

  showShy(top = window.pageYOffset) {
    document.body.classList.remove(this.shyClass);
    this.lastUp = top;
  }
};
